var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video"},[_c('video',{staticClass:"videoPlay",staticStyle:{"width":"100%","height":"100%"},attrs:{"autoplay":"","controls":"","muted":"","id":"videoElement"},domProps:{"muted":true}})])
}
var staticRenderFns = []

export { render, staticRenderFns }